// just a simple hello world with an example navigation link to another page
// use Link from gatsby to navigate through pages
import React, {useState, useEffect} from "react"
import { Link } from "gatsby"
import Contact from "../components/contact"
import Layout from "../components/layout"
import "../styles/howtomakemotorclaims.css"
import langBM from "../languages/bm"
import langEN from "../languages/en"

const LostPage = () => {
  const [isOpenContact, setOpenContact] = useState(false)
  const [lang, setLang] = useState()

  // some page is directly access (possible does not have any language)
  if(lang === undefined || lang === null || lang === ""){
    let cookieLang 
    try {
      cookieLang = document.cookie.split("; ").find(row => row.startsWith("lang=")).split("=")[1]
      if (cookieLang === "BM") {
    	   setLang(langBM)
	    }else{
        setLang(langEN)
      }
    } catch (err) {
      setLang(langEN)   // default to EN
    }
  }


  return <Layout pageTitle="How to Make Motor Claims" lang={lang}>

	{/* Content for Motor Claims  */}
    <div class="container">
        <div class="faq-bg mt-1 mobile-mt_none" styles="padding-top: 10px; padding-bottom: 80px;">
            <div class="row">
                <div class="text-center col-md-8 mb-5 offset-md-2">
                    <h3 class="title">How to Make Motor Claims</h3>
                    <h2 class="mt-2 sub-title">Claim services for vehicle damage, theft, third party property damage and others.</h2>
                </div>
            </div>

            <div class="row">
                <div class="col" styles="margin-bottom: 40px;">
                    <p>Here are the general guidelines to adopt in the event of a possible claim happening:</p>
                    <ul>
                    <li>To lodge a police report within 24 hours from the time of the accident.</li>
                    <li>To notify us of the accident as soon as possible.</li>
                    <li>Arrange to send your damaged vehicle to the nearest authorised panel workshop.</li>
                    <li>All correspondence received from third parties must be forwarded to our company.</li>
                    <li>Do not admit liability and do not negotiate or offer compensation to any third party.</li>
                    <li>Click <a href="https://www.berjayasompo.com.my/_uploads/files/forms/personals/private-motor/forms/ENG_FA%20Final.pdf" target="_blank">here</a> to download the Claims Guide for Motor Accidents.</li>
                    </ul>
                    <p><a href="https://www.berjayasompo.com.my/_uploads/files/forms/Notice%20to%20policyholders_(ENG)%20-%20Private%20Car%20Comprehensive_BMC_04092020.pdf" target="_blank">Notice to Private Car Comprehensive Policyholders<i class="fa fa-caret-right">&nbsp;</i></a></p>
                    <p><a href="https://www.berjayasompo.com.my/_uploads/files/forms/Notis%20kepada%20Pemegang%20Polisi%20Kereta%20Persendirian%20(BM)_BMC_04092020.pdf" target="_blank">Notis kepada Pemegang Polisi Kereta Persendirian<i class="fa fa-caret-right">&nbsp;</i></a></p>
                </div>
            </div>

            <br />
            <div id="accordion0">
                <div class="card">
                    <div class="card-header">
                        <h4 class="mb-0">
                            <button class="btn collapsed btn-articles" data-target="#col0" data-toggle="collapse" id="motor-accident-damage-claim">
                                <span class="ico-plus_faq">+ </span>
                                <h2 class="tx-title_faq">Motor Accident Damage Claim</h2>
                            </button>
                        </h4>
                    </div>

                    <div class="collapse" data-parent="#accordion0" id="col0" styles="">
                        <div class="card-body">
                            <p><span class="text-highlight"><strong>Documentation required for claims purposes:</strong></span></p>

                            <ul styles="list-style-type: circle;">
                                <li>Duly signed and completed <a href="https://www.berjayasompo.com.my/_uploads/files/forms/personals/private-motor/forms/MOTOR%20CLAIM%20FORM_BMC_14082020.pdf" target="_blank">Motor Claim&nbsp;Form</a>.</li>
                                <li>Copy of insurance policy schedule /&nbsp;cover note.</li>
                                <li>Police report.</li>
                                <li>Copy of updated registration card (both side)/ Vehicle Ownership Certificate</li>
                                <li>Copy of road tax disc.</li>
                                <li>Copy of Insured's identity card.</li>
                                <li>Copy of Form 9 or 13, for company-owned vehicle.</li>
                                <li>Copy of driver's identity card and driving license.</li>
                                <li>Workshop estimate for repairs.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <div id="accordion1">
                <div class="card">
                    <div class="card-header">
                        <h4 class="mb-0">
                            <button class="btn collapsed btn-articles" data-target="#col1" data-toggle="collapse" id="motor-accident-damage-claim-ODKFK">
                                <span class="ico-plus_faq">+ </span>
                                <h2 class="tx-title_faq">Motor Accident Damage Claim (Insured Not At Fault - ODKFK)*</h2>
                            </button>
                        </h4>
                    </div>

                    <div class="collapse" data-parent="#accordion1" id="col1" styles="">
                        <div class="card-body">
                            <p><span class="text-highlight"><strong>Documentation required for claims purposes:</strong></span></p>

                            <ul styles="list-style-type: circle;">
                                <li>Duly signed and completed <a href="https://www.berjayasompo.com.my/_uploads/files/forms/personals/private-motor/forms/MOTOR%20CLAIM%20FORM_BMC_14082020.pdf" target="_blank">Motor Claim&nbsp;Form</a>.</li>
                                <li>Copy of insurance policy schedule /&nbsp;cover note.</li>
                                <li>Police report.</li>
                                <li>Copy of updated registration card (both side)/ Vehicle Ownership Certificate</li>
                                <li>Copy of road tax disc.</li>
                                <li>Copy of Insured's identity card.</li>
                                <li>Copy of Form 9 or 13, for company-owned vehicle.</li>
                                <li>Copy of driver's identity card and driving license.</li>
                                <li>Copy of duly signed ODKFK declaration form.</li>
                                <li>Copy of all third parties' police reports.</li>
                                <li>Police investigation outcome.</li>
                                <li>JPJ search of third party vehicle /&nbsp;Third party vehicle's insurance information.</li>
                                <li>Workshop estimate for repairs.</li>
                            </ul>
                            <p><em>*You may make a claim under this claim type provided always that the third party vehicle is insured, identifiable, and / or not a vehicle used for carriage of passengers for hire or reward (e.g. taxis, hire cars, public buses, and others), not a vehicle insured by non-Malaysian insurers, and there is no personal injury claim involved.</em></p>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <div id="accordion2">
                <div class="card">
                    <div class="card-header">
                        <h4 class="mb-0">
                            <button class="btn collapsed btn-articles" data-target="#col2" data-toggle="collapse" id="motor-accident-damage-claim-Theft">
                                <span class="ico-plus_faq">+ </span>
                                <h2 class="tx-title_faq">Motor Theft Claim</h2>
                            </button>
                        </h4>
                    </div>

                    <div class="collapse" data-parent="#accordion2" id="col2" styles="">
                        <div class="card-body">
                            <p><span class="text-highlight"><strong>Documentation required for claims purposes:</strong></span></p>

                            <ul styles="list-style-type: circle;">
                                <li>Duly signed and completed <a href="https://www.berjayasompo.com.my/_uploads/files/forms/personals/private-motor/forms/MOTOR%20CLAIM%20FORM_BMC_14082020.pdf" target="_blank">Motor Claim Form</a>.</li>
                                <li>Copy of insurance policy schedule / cover note.</li>
                                <li>Police report.</li>
                                <li>Copy of updated registration card (both side)/ Vehicle Ownership Certificate</li>
                                <li>Copy of road tax disc.</li>
                                <li>Copy of Insured's identity card.</li>
                                <li>Copy of Form 9 or 13, for company-owned vehicle.</li>
                                <li>Copy of driver's identity card and driving license.</li>
                                <li>Copy of Hire Purchase Agreement, if any.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <div id="accordion3">
                <div class="card">
                    <div class="card-header">
                        <h4 class="mb-0">
                            <button class="btn collapsed btn-articles" data-target="#col3" data-toggle="collapse" id="motor-accident-damage-claim-Windscreen">
                                <span class="ico-plus_faq">+ </span>
                                <h2 class="tx-title_faq">Windscreen Claim</h2>
                            </button>
                        </h4>
                    </div>

                    <div class="collapse" data-parent="#accordion3" id="col3" styles="">
                        <div class="card-body">
                            <p><span class="text-highlight"><strong>Insured is strictly required to carry out the repair or replacement of the damaged windscreen or window glass only at our panel of Windscreen repairs and replacement centres, collision repair workshops or DRS Quality workshops.</strong></span></p><br />
                            <p><span class="text-highlight"><strong>Documentation required for claims purposes:</strong></span></p>

                            <ul styles="list-style-type: circle;">
                                <li>Duly signed and completed <a href="https://www.berjayasompo.com.my/_uploads/files/forms/personals/private-motor/forms/MOTOR%20CLAIM%20FORM_BMC_14082020.pdf" target="_blank">Motor Claim Form.</a></li>
                                <li>Copy of insurance policy schedule /&nbsp;cover note.</li>
                                <li>Copy of updated registration card (both side)/ Vehicle Ownership Certificate</li>
                                <li>Copy of road tax disc.</li>
                                <li>Copy of Insured's identity card.</li>
                                <li>Copy of Form 9 or 13, for company-owned vehicle.</li>
                                <li>Copy of driver's identity card and driving license.</li>
                                <li>Original photographs before &amp; after repair of damaged windscreen with imprint date (must show the full view of the vehicle, a close-up view of the damaged windscreen, manufacturer of the glass, and the damaged windscreen removed from the vehicle).</li>
                                <li>Original repairer's bill /&nbsp;receipt.</li>
                                <li>Payment authorisation letter to repairer.</li>
                                <li>Tinted bill and warranty card for previous and new replacement (if the insured vehicle was fitted with tinted film at time of loss).</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <div id="accordion4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="mb-0">
                            <button class="btn collapsed btn-articles" data-target="#col4" data-toggle="collapse" id="motor-accident-damage-claim-Bodily">
                                <span class="ico-plus_faq">+ </span>
                                <h2 class="tx-title_faq">Third Party Property Damage or Third Party Bodily Injury (For notification purposes only)</h2>
                            </button>
                        </h4>
                    </div>

                    <div class="collapse" data-parent="#accordion4" id="col4" styles="">
                        <div class="card-body">
                            <p><span class="text-highlight"><strong>Documentation required for claims purposes:</strong></span></p>

                            <ul styles="list-style-type: circle;">
                                <li>Duly signed and completed <a href="https://www.berjayasompo.com.my/_uploads/files/forms/personals/private-motor/forms/MOTOR%20CLAIM%20FORM_BMC_14082020.pdf" target="_blank">Motor Claim&nbsp;Form</a>.</li>
                                <li>Copy of insurance policy schedule / cover note.</li>
                                <li>Police report.</li>
                                <li>Copy of updated registration card (both side)/ Vehicle Ownership Certificate</li>
                                <li>Copy of road tax disc.</li>
                                <li>Copy of Insured's identity card.</li>
                                <li>Copy of Form 9 or 13, for company-owned vehicle.</li>
                                <li>Copy of driver's identity card and driving license.</li>
                                <li>All correspondence from third party / third party solicitor.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    

<Contact 
    isOpen={isOpenContact} 
    toggle={() => setOpenContact(v => !v)}
    lang={lang}
  />

</Layout>
}
export default LostPage